import { computed } from "vue";
import { defineStore } from "pinia";

import { useAuthStore } from "./auth";
import { useCompanyStore } from "./company";

export const useUserContextStore = defineStore("userContext", () => {
  const authStore = useAuthStore();
  const companyStore = useCompanyStore();

  const which = computed(() => {
    if (authStore.selectedEmployee?.company) {
      return "employee";
    }
    if (companyStore.selectedCompanyId) {
      return "company";
    }
    return "unknown";
  });

  const company = computed(() => {
    return companyStore.selected;
  });

  /** Prefer active profile's company id, then selected company (kept in sync via e.g. EmployeeComboBox). */
  const companyId = computed(() => {
    const fromProfile = authStore.selectedEmployee?.company?.id;
    if (fromProfile) return fromProfile;
    return companyStore.selectedCompanyId ?? null;
  });

  return { which, company, companyId };
});
